// How each word on a call's word wall is drawn. Adam, 2026-10-04: "words on
// wws can be different colors as well" and "use color, size, font, boldness
// deliberately and sparingly". The same rules as Seamless's own wallStyle in
// its src/lib, so the wall reads the same in both apps:
//
// - size follows weight;
// - quotes are serif italic, ideas sans;
// - the accent goes only on the top items, weight 5, at most four of them;
// - a quote's tone follows its speaker: the reader's own lines in ink,
//   everyone else's in one muted accent;
// - bold only on ideas of weight 4 and up;
// - everything else is ink at an opacity set by weight.

import type { CallWallItem } from "@breeze/core";

const MAX_ACCENT = 4;

/** The class names for every item on the wall, in order. */
export function wallStyles(items: readonly CallWallItem[]): string[] {
  let accents = 0;
  return items.map((it) => {
    const classes = ["wall__item", it.kind === "quote" ? "wall__quote" : "wall__idea", `wall--w${it.weight}`];
    if (it.weight === 5 && accents < MAX_ACCENT) {
      accents++;
      classes.push("wall--accent");
    } else if (it.kind === "quote" && !it.mine) {
      classes.push("wall--theirs");
    }
    if (it.kind === "idea" && it.weight >= 4) classes.push("wall--bold");
    return classes.join(" ");
  });
}
